import {AfterViewChecked, Component, ElementRef, inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {IFrameComponent, iframeResizer} from "iframe-resizer";
import {Subject, takeUntil} from "rxjs";
import {ImmosucheService} from "./service/admin-data/immosuche.service";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {ILocalizationService, PortalContext} from "@de.fiduciagad.kundenportal/ui-context";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    TranslateModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, AfterViewChecked, OnDestroy {
  /** private attributes */
  private readonly portalContext = inject(PortalContext);
  private readonly translate = inject(TranslateService);
  private readonly immosucheService = inject(ImmosucheService);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly unsubscribtionsSubject = new Subject();

  /** public attributes */
  isImmosucheAdminActive = false;

  @ViewChild('immosucheIframe') immosucheIframe!: ElementRef<HTMLIFrameElement>;
  iframeResizer: IFrameComponent[] = [];


  url: SafeResourceUrl | undefined;

  constructor() {
    // subscribe Sprachwechsel des PortalContext
    (this.portalContext.getLocalizationService() as ILocalizationService)?.localeChanges?.pipe(takeUntil(this.unsubscribtionsSubject))
      .subscribe((locale: string) => {
        this.translate?.use(locale);
      });
  }

  ngOnInit(): void {
    this._fetchSettingsAdminData();
  }

  ngAfterViewChecked() {
    if (this.immosucheIframe && this.iframeResizer.length === 0) {
      this.iframeResizer = iframeResizer({log: false, checkOrigin: false}, this.immosucheIframe.nativeElement);
    }
  }

  ngOnDestroy() {
    if (this.iframeResizer.length > 0) {
      this.iframeResizer[0].remove();
    }
    this.unsubscribtionsSubject.next(true);
    this.unsubscribtionsSubject.complete();
  }

  private _fetchSettingsAdminData() {
    this.immosucheService.ladeEinstellungenImmosuche().pipe(takeUntil(this.unsubscribtionsSubject)).subscribe({
      next: (immosucheResponse) => {

        if (!immosucheResponse.immoSucheAktiv) {
          return;
        }

        this.isImmosucheAdminActive = immosucheResponse.immoSucheAktiv;
        this.url = this._buildImmosucheUrlPerUmgebung(immosucheResponse.mandantenId,
          immosucheResponse.produktiv
        );

      },
    });
  }

  private _buildImmosucheUrlPerUmgebung(mandantenId: string, produktiv: boolean) {
    const mainUrl = produktiv ? 'https://wohnglueck.de' : 'https://immofinder.stage.impleco.de';
    return this.domSanitizer.bypassSecurityTrustResourceUrl(`${mainUrl}/embed/atruvia-widget/${mandantenId}`);
  }

}

@Component({
  selector: 'app-root-homepage',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    TranslateModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponentHomepage extends AppComponent {

}
